import axios from 'axios'

export const companiesCompany = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    message: null,
    errors: null,
  },
  mutations: {
    readCompany(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readCompanySuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    readCompanyFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    }
  },
  getters: {
    company(state) {
      return state.data.attributes
    },
    // 口コミ返信テンプレート
    providedFeaturesReplyTemplate(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('reply_template')
    },
    // URL連携
    providedFeaturesLinkUrl(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('link_url')
    },
    // ID/PASS連携
    providedFeaturesExternalAccount(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('external_account')
    },
    // 写真ライブラリ
    providedFeaturesMediaLibrary(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('media_library')
    },
    // メニュー
    providedFeaturesFoodMenu(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('food_menu')
    },
    // 商品
    providedFeaturesProduct(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('product')
    },
    // サービス
    providedFeaturesServicePattern(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('service_pattern')
    },
    // 口コミ
    providedFeaturesReview(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('review')
    },
    // ユーザ投稿写真
    providedFeaturesPhoto(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('photo')
    },
    // 電話応対
    providedFeaturesTestimonial(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('testimonial')
    },
    // 店舗ページ
    providedFeaturesVisitor(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('visitor')
    },
    // アンケート
    providedFeaturesSurvey(state){
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('survey')
    },
    // GMB投稿
    providedFeaturesPost(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('post')
    },
    // 口コミサイトアクセス分析
    providedFeaturesAnalysisInsight(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_insight')
    },
    // ★の数分析
    providedFeaturesAnalysisReview(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_review')
    },
    // 口コミ相関分析
    providedFeaturesAnalysisScatter(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_scatter')
    },
    // ランキング
    providedFeaturesAnalysisRanking(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_ranking')
    },
    // 口コミAI分析
    providedFeaturesAnalysisQsca(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_qsca')
    },
    // 店舗ページアクセス分析
    providedFeaturesAnalysisVisitor(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_visitor')
    },
    // アンケート分析
    providedFeaturesAnalysisSurvey(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_survey')
    },
    // キーワード分析
    providedFeaturesAnalysisKeyword(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_keyword')
    },
    // 検索ワード分析
    providedFeaturesAnalysisSearchKeywordImpression(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('analysis_search_keyword_impression')
    },
    // 競合
    providedFeaturesCompetitor(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('competitor')
    },
    // CSVエクスポート
    providedFeaturesCsvExport(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('csv_export')
    },
    // 投稿承認
    providedFeaturesPostApprovalFlow(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('post_approval_flow')
    },
    // SNS投稿
    providedFeaturesSns(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('sns')
    },
    // SNS承認
    providedFeaturesSnsApprovalFlow(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('sns_approval_flow')
    },
    // 口コミ返信承認
    providedFeaturesReviewReplyApprovalFlow(state) {
      if(!state.data) return false
      return state.data.attributes.provided_features.includes('reply_approval_flow')
    },
    providedFeaturesInitialSettingGuide(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('initial_setup_guide')
    },
    // 営業時間クローラー
    providedFeaturesBusinessHoursCrawler(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('business_hours_crawler')
    },
    // 口コミAI返信サポート
    providedFeaturesAutoGenerateReply(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('auto_generate_reply')
    },
    // AI投稿サポート
    providedFeaturesAiPostSupport(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('ai_post_support')
    },
    // QSCA分析
    providedAiReviewSentencesAnalysis(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('ai_review_sentences_analysis')
    },
    // 特典機能
    providedFeaturesBenefit(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('benefit')
    },
    // 最新のお知らせ
    providedFeaturesNotification(state) {
      if (!state.data) return notification
      return state.data.attributes.provided_features.includes('notification')
    },
    // 店舗一括編集
    providedFeaturesBulkUpdate(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('bulk_update')
    },
    // 店舗オプション一括編集
    providedFeaturesBulkUpdateStoreOption(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('bulk_update_store_option')
    },
    // 店舗詳細オプション
    providedFeaturesStoreOption(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('store_option')
    },
    // 店舗詳細SNS
    providedFeaturesStoreSocial(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('store_social')
    },
    // オリジナルタグ
    providedFeaturesOriginalTagGroup(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('original_tag_group')
    },
    // フランチャイズ
    providedFeaturesFranchisee(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('franchisee')
    },
    // 立地
    providedFeaturesArea(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('area')
    },
    // 絞り込み条件メール設定
    providedFeaturesSearchPattern(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('search_pattern')
    },
    // gmb関連
    providedFeaturesGmb(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('gmb')
    },
    // shufoo関連
    providedFeaturesShufoo(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('shufoo')
    },
    // mapion_biz関連
    providedFeaturesMapionBiz(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('mapion_biz')
    },
    // 店舗支払い
    providedFeaturesPaymentMethod(state) {
      if (!state.data) return false
      return state.data.attributes.provided_features.includes('payment_method')
    },
    hasAvailableFranchiseesStoreOption(state) {
      if (!state.data) return false
      return state.data.attributes.has_available_franchisees_store_option
    },
    hasAvailableUserCompanyStoreOption(state) {
      if (!state.data) return false
      return state.data.attributes.has_available_user_company_store_option
    },
    hasAvailableAreaStoreOption(state) {
      if (!state.data) return false
      return state.data.attributes.has_available_area_store_option
    },
    hasAvailableSnsApprovalFlow(state) {
      if (!state.data) return false
      return state.data.attributes.has_available_sns_approval_flow
    },
    gmbSearchKeywordImpressionsAnalysis(state) {
      if (!state.data) return false
      return state.data.attributes.gmb_search_keyword_impressions_analysis
    },
    canHaveFoodMenus(state) {
      if (!state.data) return false
      return state.data.attributes.can_have_food_menus
    },
    canModifyServiceList(state) {
      if (!state.data) return false
      return state.data.attributes.can_modify_service_list
    },
    directSelling(state) {
      if (!state.data) return false
      return state.data.attributes.direct_selling
    },
    isRettyDistributer(state) {
      if (!state.data) return false
      return state.data.attributes.is_retty_distributer
    },
    hasReadableCompetitors(state) {
      if (!state.data) return false
      return state.data.attributes.num_of_readable_competitors > 0
    },
    hasLoadError(state) {
      return state.loadError
    },
    hasAvailableProduct(state) {
      if (!state.data) return false
      return state.data.attributes.has_available_product
    },
    hasAvailableSearchGroup(state) {
      if (!state.data) return false
      return state.data.attributes.has_available_search_group
    },
    useServiceName(state) {
      if (!state.data) return false
      return state.data.attributes.use_service
    },
    canDisplayChangeUi(state) {
      if (!state.data) return false
      return !state.data.attributes.lock_browser_edit
    },
    plan(state){
      return state.data.attributes.plan
    },
    moreThanLitePlan(state) {
      return ['lite', 'basic'].includes(state.data.attributes.plan)
    },
    isDocomoPlan(state) {
      if (!state.data) return false
      return state.data.attributes.plan === 'docomo'
    },
    isRettyPlan(state) {
      if (!state.data) return false
      return state.data.attributes.plan === 'retty'
    },
    isEnterprisePlan(state) {
      if (!state.data) return false
      return state.data.attributes.plan === 'basic'
    },
    hasMapionBizStore(state) {
      return state.data.attributes.has_mapion_biz_store
    },
    inboundOption(state) {
      if (!state.data) return false
      return state.data.attributes.inbound_option
    },
    hasGmbAccount(state) {
      if(!state.data) return false
      return state.data.attributes.has_gmb_account
    },
    hasGmbStore(state) {
      if(!state.data) return false
      return state.data.attributes.has_gmb_store
    },
    hasDocomoStore(state) {
      if(!state.data) return false
      return state.data.attributes.has_docomo_store
    },
    hasYahooPlaceStore(state) {
      if(!state.data) return false
      return state.data.attributes.has_yahoo_place_store
    },
    postApprovalFlow(state) {
      if (!state.data) return false
      return state.data.attributes.post_approval_flow
    },
    snsApprovalFlow(state) {
      if (!state.data) return false
      return state.data.attributes.sns_approval_flow
    },
    replyApprovalFlow(state) {
      if (!state.data) return false
      return state.data.attributes.reply_approval_flow
    },
    canConnectToGoogleApi(state){
      if (!state.data) return false
      return state.data.attributes.can_connect_to_google_api
    },
    taishuTenpyoOption(state) {
      if (!state.data) return false
      return state.data.attributes.taishu_tenpyo_option
    }
  },
  actions: {
    async readCompany({ commit }, companyUuid) {
      commit('readCompany')
      return axios
        .get('/api/companies/'+ companyUuid +'.json')
        .then(res => {
          commit('readCompanySuccess', res.data)
          return res.data
        })
        .catch(err => {
          commit('readCompanyFailure', err)
          console.error(err)
        })
    },
  },
}
